import EventRegister from "./event_register";

class AutoComplete {

  static init() {
    EventRegister.promisseRegister("[role='autocomplete']", "input",  function() { AutoComplete.search(this); });
    EventRegister.promisseRegister("[role='autocomplete']", "click",  function(e) { AutoComplete.clickOut(e, this); });
  }

  static clickOut(input) {
    var list = document.getElementById(input.name + "_autocomplete_list");
    if (list && !input.contains(e.target)) list.remove();
  }

  static search(input) {
    clearTimeout(input._autocompleteTimeout);
    input._autocompleteTimeout = setTimeout(function() {
      var query = input.value;
      if (query.length < 3) return;
      const source_url = input.getAttribute("source_url");
      if (!source_url) return;
      fetch(`${source_url}?q=` + encodeURIComponent(query))
        .then(response => response.json())
        .then(data => { AutoComplete.createList(input, data); })
        .catch((reason) => { console.debug(reason); return {} });
    }, 1000);
  }

  static createList(input, data) {
    var listId = input.name + "_autocomplete_list";
    var oldList = document.getElementById(listId);
    if (oldList) oldList.remove();
    var list = document.createElement("ul");
    list.id = listId;
    list.classList.add("autocomplete_list");
    list.style.width = input.offsetWidth + "px";
    data.forEach(function(item) {
      AutoComplete.createListItem(item, input, list);
    });
    input.after(list);
  }

  static createListItem(item, input, list) {
    var li = document.createElement("li");
    li.textContent = item.email;
    li.classList.add("autocomplete_list_item");
    li.onclick = function() {
      input.value = item.email;
      list.remove();
    };
    list.appendChild(li);
  }

}

AutoComplete.init();
export default AutoComplete;
